module.exports = __webpack_public_path__ + "static/img/buy_es.83abd2ea.png";